global.businessProfileUpdate = global.API_BUSINESS_URL+'businessProfileUpdate/';
global.businessPasswordUpdate = global.API_BUSINESS_URL+'businessPasswordUpdate/';
global.businessProfilePicUpdate = global.API_BUSINESS_URL+'businessProfilePicUpdate/';